var map = {
	"./FSicon.png": 1220,
	"./Strype-logo-128-2x.png": 8763,
	"./disabledRedo.svg": 5081,
	"./disabledUndo.svg": 5751,
	"./forbidden-cursor.png": 6598,
	"./logoGDrive.png": 3064,
	"./mask_background.svg": 451,
	"./plus.svg": 675,
	"./redo.svg": 6451,
	"./transferHexFile.svg": 6306,
	"./turtle.png": 7519,
	"./undo.svg": 4808,
	"./wave.png": 9674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;